import { useDispatch, useSelector } from "react-redux"
import { TourOrderWrapper } from "./styled"
import { tourOrderActions } from "redux/slice/tourOrder"
import { useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import useParams from "hooks/useParams"
import DateTimePicker from "components/DateTimePicker"
import Button from "components/Button"
import { authSelector, tourOrderSelector } from "redux/selector"
import Loading from "components/Loading"
import Image from "components/Image"
import Label from "components/Label"
import { getDiscount, get_day_of_time, setPrice } from "utils"
import { useState } from "react"
import timeNow from 'helpers/timenow'
import Modal from "components/Modal"
import { updateTourOrderType } from "common/general"
import Quantity from "components/Quantity"
import ShowToast from "utils/ShowToast"
import { FaUsers, FaRegCalendarAlt, FaPhoneAlt } from "react-icons/fa"

const TourOrder = () => {
    const dispatch = useDispatch()
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const qStatus = query.get("status");
    const { setParams } = useParams()
    const tourOrderState = useSelector(tourOrderSelector)
    const [departureDay, setDepartureDay] = useState("")
    const [dateValue, setDate] = useState(timeNow())
    const [showCancel, setShowCancel] = useState(false)
    const [showReOrder, setShowReOrder] = useState(false)
    const [showUpdate, setShowUpdate] = useState(false)
    const [tourId, setTourId] = useState(null)
    const [amountPeople, setAmountPeople] = useState(1)
    const authState = useSelector(authSelector)

    const [perSon, setPerSon] = useState({
        min: 1,
        max: 2
    })
    const [departureDayUpdate, setDepartureDayUpdate] = useState(timeNow())

    const handleReOrder = () => {
        if (parseInt(get_day_of_time(new Date(), new Date(departureDayUpdate))) > 3) {
            const data = {
                status: 0,
                departure_day: departureDayUpdate,
                amount_of_people: amountPeople,
            }
            if (!tourOrderState.loading)
                dispatch(tourOrderActions.updateTour({ id: tourId, data, type: updateTourOrderType.REORDER, departureDay: departureDay, status: (!qStatus || qStatus === "all") ? "" : Number(qStatus) }))
            setShowReOrder(false)
        } else {
            ShowToast("error", "Đặt tour thất bại, Bạn phải đặt thời gian khởi hành trước 3 ngày")
        }
    }

    const handleUpdateTourOrder = () => {
        if (parseInt(get_day_of_time(new Date(), new Date(departureDayUpdate))) > 3) {
            const data = {
                departure_day: departureDayUpdate,
                amount_of_people: amountPeople
            }
            if (!tourOrderState.loading)
                dispatch(tourOrderActions.updateTour({ id: tourId, data, type: updateTourOrderType.UPDATE, departureDay: departureDay, status: (!qStatus || qStatus === "all") ? "" : Number(qStatus) }))
            setShowUpdate(false)
        } else {
            ShowToast("error", "Cập nhật tour thất bại, Bạn phải đặt thời gian khởi hành trước 3 ngày")
        }
    }


    const handleCancelTour = () => {
        const data = {
            status: 3,
            customer_email: authState.currentUser.user.email
        }
        if (!tourOrderState.loading)
            dispatch(tourOrderActions.updateTour({ id: tourId, data, type: updateTourOrderType.CANCEL, departureDay: departureDay, status: (!qStatus || qStatus === "all") ? "" : Number(qStatus) }))
        setShowCancel(false)
    }

    useEffect(() => {
        dispatch(tourOrderActions.getTour({ departureDay: departureDay, status: (!qStatus || qStatus === "all") ? "" : Number(qStatus) }))
    }, [departureDay, dispatch, qStatus])

    return (
        <TourOrderWrapper >
            <ul className="list_status flex p-0 m-0 bg-grey2 p-0 b-radius-4">
                <li className={`list_status_item flex-center clickable ${(!qStatus || qStatus === 'all') ? "list_status_item-active" : ""}`}
                    onClick={() => setParams({ status: 'all' })}
                >
                    <span className="text-center">Tất cả</span>
                </li>
                <li
                    className={`list_status_item flex-center clickable ${(qStatus === '0') ? "list_status_item-active" : ""}`}
                    onClick={() => setParams({ status: 0 })}
                >
                    <span className="text-center">Chờ xác nhận</span>
                </li>
                <li
                    className={`list_status_item flex-center clickable ${(qStatus === '1') ? "list_status_item-active" : ""}`}
                    onClick={() => setParams({ status: 1 })}
                >
                    <span className="text-center">Đang thực hiện</span>
                </li>
                <li
                    className={`list_status_item flex-center clickable ${(qStatus === '2') ? "list_status_item-active" : ""}`}
                    onClick={() => setParams({ status: 2 })}
                >
                    <span className="text-center">Hoàn thành</span>
                </li>
                <li
                    className={`list_status_item flex-center clickable ${(qStatus === '3') ? "list_status_item-active" : ""}`}
                    onClick={() => setParams({ status: 3 })}
                >
                    <span className="text-center">Đã hủy</span>
                </li>
            </ul>
            <div className="bg-grey2 p-15 b-radius-4 mt-20">
                <div className="filter">
                    <DateTimePicker
                        dateInit={new Date(dateValue)}
                        onChangeDate={(date) => setDate(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                    />
                    <Button className="action-danger ml-20"
                        onClick={() => setDepartureDay(dateValue)}
                    >Lọc</Button>
                    <Button className="action-danger ml-20" onClick={() => setDepartureDay("")}>Xem tất cả</Button>
                </div>
                {
                    tourOrderState?.tourOrder?.length > 0 &&
                    <ul className="tour_list mt-30 px-0 bt-grey-1 pt-25">
                        {
                            tourOrderState.tourOrder.map((item, index) => (
                                <li key={index} className="tour_item mb-25 bb-grey-1 pb-25">
                                    <div className="tour_item_main">
                                        <div className="tour_image">
                                            <Image src={item.thumbnail} />
                                        </div>
                                        <div className="description ml-20">
                                            <Link
                                                to={`/tour/${item.slug}`}
                                                className="text-link s-18 clickable"
                                            >{item.name}</Link>
                                            <div className='mt-15 price'>
                                                {
                                                    item.discount > 0 &&
                                                    <strike className='regular text-grey s-20 mt-10'>{setPrice(item.price)} vnđ</strike>
                                                }
                                                <div className='bold text-red s-20'>{getDiscount(item.price, item.discount)} vnđ</div>
                                                {
                                                    item.discount > 0 &&
                                                    <div className='medium text-white s-14 b-radius-2 mt-10 sale px-5'>Giảm:{item.discount}%</div>
                                                }
                                            </div>
                                            <div className="flex mt-25">
                                                <div className="mr-30 flex">
                                                    <FaUsers className="text-link s-22" />
                                                    <span className="ml-15 medium text-red">{item.amount_of_people}</span>
                                                </div>
                                                <div className="flex">
                                                    <FaRegCalendarAlt className="text-link s-22" />
                                                    <span className="ml-15 medium text-red">{item.departure_day}</span>
                                                </div>
                                            </div>
                                            {
                                                qStatus !== "0" && item.staff_name &&
                                                <div className="flex mt-10">
                                                    <div className="mr-30 flex">
                                                        <Label className="text-link">Phụ trách:</Label>
                                                        <span className="ml-15 medium text-red">{item.staff_name}</span>
                                                    </div>
                                                    <div className="flex">
                                                        <FaPhoneAlt className="text-link s-18" />
                                                        <span className="ml-15 medium text-red">{item.staff_phone}</span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="control">
                                        {
                                            item.status === 0 && parseInt(get_day_of_time(new Date(), new Date(item.departure_day))) < 0 &&
                                            <span className="label mb-10 no-wrap " >Hết hạn</span>
                                        }
                                        {
                                            item.tour_status === 1 &&
                                            <span className="label mb-10 no-wrap ">Tạm dừng</span>
                                        }
                                        {
                                            item.status === 0 && qStatus === "0" &&
                                            <>
                                                {/* <span className="btn_update clickable mb-10"
                                                    onClick={() => {
                                                        setShowUpdate(true);
                                                        setTourId(item.id);
                                                        setPerSon({
                                                            min: item.min_person,
                                                            max: item.max_person
                                                        })
                                                        setAmountPeople(item.amount_of_people)
                                                        setDepartureDayUpdate(item.departure_day)
                                                    }}
                                                >Sửa</span> */}
                                                <span className="btn_cancel action-danger-1 clickable no-wrap "
                                                    onClick={() => { setShowCancel(true); setTourId(item.id) }}
                                                >Hủy tour</span>
                                            </>
                                        }
                                        {/* {
                                            item.status === 0 && qStatus === "3" &&
                                            <>
                                                <span className="btn_cancel action-danger-1 clickable"
                                                    onClick={() => {
                                                        setShowReOrder(true);
                                                        setTourId(item.id);
                                                        setPerSon({
                                                            min: item.min_person,
                                                            max: item.max_person
                                                        })
                                                        setAmountPeople(item.amount_of_people)
                                                        setDepartureDayUpdate(item.departure_day)
                                                    }}
                                                >Đặt lại tour</span>
                                            </>
                                        } */}
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                }
                {
                    tourOrderState.tourOrder.length === 0 &&
                    <div className="empty_data">
                        <span className="text-red medium">Danh sách trống!</span>
                    </div>
                }
            </div>
            {
                tourOrderState.loading &&
                <Loading />
            }
            {
                showCancel &&
                <Modal onClose={() => { setShowCancel(false); setTourId(null) }}>
                    <div className="cancel_form p-25">
                        <div className="pt-20 px-35">
                            <span className="text-black medium mt-30" >Bạn chắc chắn muốn hủy tour này?</span>
                        </div>
                        <div className="bt-grey-1 pt-15 mt-40 cancel-control flex">
                            <Button className="action-danger"
                                onClick={handleCancelTour}
                            >Hủy tour</Button>
                            <Button className="action-primary ml-20"
                                onClick={() => { setShowCancel(false); setTourId(null) }}
                            >Thoát</Button>
                        </div>
                    </div>
                </Modal>
            }
            {
                showReOrder &&
                <Modal onClose={() => { setShowReOrder(false); setTourId(null) }}>
                    <div className="cancel_form p-25">
                        <div className=" bb-grey-1">
                            <span className="text-black medium mt-30 text-center" >Đặt lại tour</span>
                        </div>
                        <div>
                            <div className='mt-50 flex'>
                                <Label>Số người:</Label>
                                <Quantity defaultValue={amountPeople} minValue={perSon.min} maxValue={perSon.max} handleChangeInput={(e) => setAmountPeople(e)} />
                            </div>
                            <div className='mt-20 flex'>
                                <Label className="mr-15">Thời gian bắt đầu:</Label>
                                <DateTimePicker
                                    dateInit={new Date(departureDayUpdate)}
                                    onChangeDate={(date) => setDepartureDayUpdate(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                                />
                            </div>
                        </div>
                        <div className="bt-grey-1 pt-15 mt-40 cancel-control flex">
                            <Button className="action-danger"
                                onClick={handleReOrder}
                            >Đặt lại</Button>
                            <Button className="action-primary ml-20"
                                onClick={() => { setShowReOrder(false); setTourId(null) }}
                            >Thoát</Button>
                        </div>
                    </div>
                </Modal>
            }
            {
                showUpdate &&
                <Modal onClose={() => { setShowUpdate(false); setTourId(null) }}>
                    <div className="cancel_form p-25">
                        <div className=" bb-grey-1">
                            <span className="text-black medium mt-30 text-center" >Cập nhật tour</span>
                        </div>
                        <div>
                            <div className='mt-50 flex'>
                                <Label className="mr-15">Số người:</Label>
                                <Quantity defaultValue={amountPeople} minValue={perSon.min} maxValue={perSon.max} handleChangeInput={(e) => setAmountPeople(e)} />
                            </div>
                            <div className='mt-20 flex'>
                                <Label className="mr-15">Thời gian bắt đầu:</Label>
                                <DateTimePicker
                                    dateInit={new Date(departureDayUpdate)}
                                    onChangeDate={(date) => setDepartureDayUpdate(`${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`)}
                                />
                            </div>
                        </div>
                        <div className="bt-grey-1 pt-15 mt-40 cancel-control flex">
                            <Button className="action-danger"
                                onClick={handleUpdateTourOrder}
                            >Sửa</Button>
                            <Button className="action-primary ml-20"
                                onClick={() => { setShowUpdate(false); setTourId(null) }}
                            >Thoát</Button>
                        </div>
                    </div>
                </Modal>
            }
        </TourOrderWrapper>
    )
}

export default TourOrder